function InitialCtrl($scope, $attrs, $parse) {
    'ngInject';

    let val = $attrs.ngInitial || $attrs.value;
    const getter = $parse($attrs.ngModel);
    const setter = getter.assign;
    if (val === 'true') {
        val = true;
    } else if (val === 'false') {
        val = false;
    }
    setter($scope, val);
}

function initialDirective() {
    'ngInject';

    return {
        restrict: 'A',
        controller: InitialCtrl
    };
}

angular
    .module('BB')
    .directive('ngInitial', initialDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/ng-initial/ng_initial.directive.js